module.exports = __webpack_public_path__ + "static/media/img_weihu@2x.9d37e8a2.png";